import React, { Component, PropTypes } from 'react';
import Icon from '../../tc-ui/icon';

class ProductCode extends Component {

  getEditProductCodeIcon = () => {
    const { profileToShow, editField } = this.props;
    return (
      <div style={{ display: 'inline-block', marginLeft: '8px', fontSize: '16px' }}
        className="profile-edit-icon-container"
        onClick={editField.bind(this, 'productCode', { type: 'productCode' })}
      >
        <Icon className={profileToShow.productCode ? 'tc-icon-mode_edit profile-edit-icon' : 'tc-icon-add description-segments-add-icon'}/>
        {profileToShow.productCode ? 'EDIT' : 'Add Product Code'}
      </div>
    );
  };


  render() {
    const { profileToShow, isEditable, routeName } = this.props;
    const productCode = profileToShow.productCode && routeName === 'product' ? profileToShow.productCode : undefined;
    if (profileToShow.productCode || isEditable && routeName === 'product') {
      return (
        <span style={{ display: 'block', whiteSpace: 'pre-wrap' }}>
          {productCode ? `Product Code: ${productCode}` : undefined}
          {routeName === 'product' && isEditable ? this.getEditProductCodeIcon() : undefined}
        </span>
      );
    }
    return false;
  }
}

ProductCode.propTypes = {
  profileToShow: PropTypes.object,
  editField: PropTypes.func,
  isEditable: PropTypes.bool,
  routeName: PropTypes.string,
};

export default ProductCode;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/product-code.jsx